import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Copy = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" transform="translate(0.5)" fill="none" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.95804 12.0781C6.12961 12.0781 5.45804 11.4066 5.45804 10.5781V2.51562C5.45804 1.6872 6.12961 1.01562 6.95804 1.01562H13.0518C13.8802 1.01562 14.5518 1.6872 14.5518 2.51562V10.5781C14.5518 11.4066 13.8802 12.0781 13.0518 12.0781H6.95804ZM6.45804 10.5781C6.45804 10.8543 6.6819 11.0781 6.95804 11.0781H13.0518C13.3279 11.0781 13.5518 10.8543 13.5518 10.5781V2.51562C13.5518 2.23948 13.3279 2.01562 13.0518 2.01562H6.95804C6.6819 2.01562 6.45804 2.23948 6.45804 2.51562V10.5781ZM4.50003 15.0781C3.39546 15.0781 2.50003 14.1827 2.50003 13.0781V5.5C2.50003 4.67157 3.1716 4 4.00003 4H4.55179V5H4.00003C3.72389 5 3.50003 5.22386 3.50003 5.5V13.0781C3.50003 13.6304 3.94775 14.0781 4.50003 14.0781H11.0205C11.2967 14.0781 11.5205 13.8543 11.5205 13.5781V12.9688H12.5205V13.5781C12.5205 14.4066 11.849 15.0781 11.0205 15.0781H4.50003Z"
        fill={color}
      />
    </svg>
  )
})

export default Copy
